/**
 * @generated SignedSource<<e1103cf3f40c4eb0d896f70c4caf5e0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RepeatTypeEnum = "daily" | "monthly" | "weekly" | "%future added value";
export type AppPushCreateInput = {
  csvFile?: Upload | null;
  deeplink?: string | null;
  description?: string | null;
  isRepeat: boolean;
  pushBody: string;
  pushTitle: string;
  query: string;
  repeatType?: RepeatTypeEnum | null;
  repeatValue?: string | null;
  startAt: any;
  title: string;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type AppPushCreateDialog_appPushCreateMutation$variables = {
  input: AppPushCreateInput;
};
export type AppPushCreateDialog_appPushCreateMutation$data = {
  readonly appPushCreate: {
    readonly id: string;
  };
};
export type AppPushCreateDialog_appPushCreateMutation = {
  response: AppPushCreateDialog_appPushCreateMutation$data;
  variables: AppPushCreateDialog_appPushCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AppPush",
    "kind": "LinkedField",
    "name": "appPushCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppPushCreateDialog_appPushCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppPushCreateDialog_appPushCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cda72e407614fe2ad1e01a303358b8e5",
    "id": null,
    "metadata": {},
    "name": "AppPushCreateDialog_appPushCreateMutation",
    "operationKind": "mutation",
    "text": "mutation AppPushCreateDialog_appPushCreateMutation(\n  $input: AppPushCreateInput!\n) {\n  appPushCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9cdd980dfe047116bc33520f84b82ce3";

export default node;
